import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
//import "./Special/special.css";
import Button from 'react-bootstrap/Button';
import BackEndLogListCard from './back_end_log_list_card';
import DropDownOptionCard from '../shared-components/drop_down_option_card';

class BackEndLogReport extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleGameIdChange.bind(this);
    this.handleClick = this.handleProcessNameChange.bind(this);
    this.handleClick = this.handleMetricNameChange.bind(this);
    this.state={
        gameID: "none",
        processName: "none",
        metricName: "none",
    }    
    this.backEndLogData = JSON.parse(JSON.stringify(this.props.backEndLogData));
    this.filteredBackEndLogData = this.backEndLogData;
    this.filterOptions();
}

filterOptions(){
     this.gameIdArr = [];
     this.processNameArr = [];
     this.metricNameArr = [];
     for (let i=0; i<this.backEndLogData.length; i++){
        const backEndLog = this.backEndLogData[i];
        const gameIdObj = this.gameIdArr.find(elem => elem.value === backEndLog.gameID);
        if (!gameIdObj){
            const gameIdObj = {value: backEndLog.gameID, selection: backEndLog.gameID};
            this.gameIdArr.push(gameIdObj)
        }
     }
     for (let i=0; i<this.filteredBackEndLogData.length; i++){
        const backEndLog = this.filteredBackEndLogData[i];
        const processNameObj = this.processNameArr.find(elem => elem.value === backEndLog.processName);
        if (!processNameObj){
            const processNameObj = {value: backEndLog.processName, selection: backEndLog.processName};
            this.processNameArr.push(processNameObj);
        }
        const metricNameObj = this.metricNameArr.find(elem => elem.value === backEndLog.metricName);
        if (!metricNameObj){
            const metricNameObj = {value: backEndLog.metricName, selection: backEndLog.metricName};
            this.metricNameArr.push(metricNameObj);
        }
     }
     const defaultOption = {value: "none", selection: "No Option Selected"};
     this.gameIdArr.unshift(defaultOption);
     this.processNameArr.unshift(defaultOption);
     this.metricNameArr.unshift(defaultOption);
}

handleGameIdChange(gameID){
    this.filterBackEndLogDataset({fieldName: "gameID", fieldValue: gameID});
    this.setState({gameID: gameID});
}

handleProcessNameChange(processName){
    this.filterBackEndLogDataset({fieldName: "processName", fieldValue: processName});
    this.setState({processName: processName});
}

handleMetricNameChange(metricName){
    this.filterBackEndLogDataset({fieldName: "metricName", fieldValue: metricName});
    this.setState({metricName: metricName});
}

filterBackEndLogDataset(filterParm){
    this.filteredBackEndLogData = this.backEndLogData;
    let gameID = this.state.gameID;
    let processName = this.state.processName;
    let metricName = this.state.metricName;
 
    switch (filterParm.fieldName){
        case "gameID":
            gameID = filterParm.fieldValue;
            processName = "none";
            metricName = "none";
            break;
        case "processName":
            processName = filterParm.fieldValue;
            metricName = "none";
            break;
        case "metricName":
            metricName = filterParm.fieldValue;
            break;
        default:
            break;
    }
    this.filteredBackEndLogData = JSON.parse(JSON.stringify(this.backEndLogData));
    if (gameID !== "none"){
        this.filteredBackEndLogData = this.filteredBackEndLogData.filter(elem => elem.gameID === gameID);
    }
    if (processName !== "none"){
        this.filteredBackEndLogData = this.filteredBackEndLogData.filter(elem => elem.processName === processName);
    }
    this.numeric = false;
    if (metricName !== "none"){
        this.filteredBackEndLogData = this.filteredBackEndLogData.filter(elem => elem.metricName === metricName);
        const metricTest = +this.filteredBackEndLogData[0].metricValue;
        if (!isNaN(metricTest)){
            this.numeric = true;
            this.calculateMetricTotals();
        }
    }
    this.filterOptions();
}

calculateMetricTotals(){
    let totalValue = 0;
    this.maxValue = 0;
    this.minValue = 9999;
    for (let i=0; i<this.filteredBackEndLogData.length; i++){
        const logData = this.filteredBackEndLogData[i];
        if (+logData.metricValue > this.maxValue){
            this.maxValue = +logData.metricValue;
        }
        if (+logData.metricValue < this.minValue){
            this.minValue = +logData.metricValue;
        }
        totalValue += +logData.metricValue;
    }
    this.average = (totalValue / this.filteredBackEndLogData.length).toFixed(2);
}

   
render() {
  
    const logReportInfo = this.filteredBackEndLogData.map((logData, index) =>
        <BackEndLogListCard logData={logData}  key={index}  
        index={index}/>
            );

    const gameIDOptions = this.gameIdArr.map((optionsList,index) =>
        <DropDownOptionCard options={optionsList} key={index} />
        );

    const processNameOptions = this.processNameArr.map((optionsList,index) =>
        <DropDownOptionCard options={optionsList} key={index} />
        );

    const metricNameOptions = this.metricNameArr.map((optionsList,index) =>
        <DropDownOptionCard options={optionsList} key={index} />
        );
                    
return <>
  
    <Modal className="text-center" show={this.props.show}  onHide={() => this.props.onClose()} 
       size="xl" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title>
                Back End Log Report      
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="row text-left mx-4">
                <div className="col-6">
                    <b>Total Number of Records: </b> {this.filteredBackEndLogData.length}
                </div>
                {this.numeric  ? 
                    <div className="col-6">
                        <b>Average Value: </b> {this.average}
                    </div>
                :
                    null

                }
            </div>
            {this.numeric ?
                <div className="row text-left mx-4">
                    <div className="col-6">
                        <b>Minimum Value: </b> {this.minValue}
                    </div>
                    <div className="col-6">
                        <b>Maximum Value: </b> {this.maxValue}
                    </div>
                </div>
            :
                null
            }
            {/* solid line */}
            <hr style={{ border: 'none', borderTop: '1px solid #110808dd', margin: '16px 0' }} />
            <div className="row mt-4">
                 <div className = "col-4">
                    <label className="font-weight-bold mx-2" htmlFor="gameID">Game ID:&nbsp;</label>
                        <select onChange={(val) => this.handleGameIdChange(val.target.value)}
                        value={this.state.gameID}
                        className="btn btn-sm btn-outline-secondary dropdown-toggle" id="gameID"  >
                            {gameIDOptions}
                    </select>
                </div>
                 <div className = "col-4">
                    <label className="font-weight-bold mx-2" htmlFor="processName">Process Name:&nbsp;</label>
                        <select onChange={(val) => this.handleProcessNameChange(val.target.value)}
                        value={this.state.processName}
                        className="btn btn-sm btn-outline-secondary dropdown-toggle" id="processName"  >
                            {processNameOptions}
                    </select>
                </div>
                <div className = "col-4">
                    <label className="font-weight-bold mx-2" htmlFor="metricName">Metric Name:&nbsp;</label>
                    <select onChange={(val) => this.handleMetricNameChange(val.target.value)}
                        value={this.state.metricName}
                        className="btn btn-sm btn-outline-secondary dropdown-toggle" id="metricName"  >
                            {metricNameOptions}
                    </select>
                </div>
            </div>

              <table className="table table-no-space table-hover mt-4">
                <tbody>
                  <tr>
                    <th>Process Name</th>
                    <th>Metric Name</th>
                    <th>Metric Value</th>
                    <th>Comment</th>
                    <th>Dt Added</th>
                    <th>Seq</th>
                    <th>Time Added</th>
                </tr>
                  {logReportInfo}
                </tbody>
              </table>

        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom" >
            <Button variant="primary"  onClick={() => this.props.onClose()}>
                Close
            </Button>
                        
        </Modal.Footer>
       
    </Modal>
    
  </>
  }
}

export default BackEndLogReport;